import { useFAQ } from "~/components/institutional/FAQ/useFAQ"

export default function Questions() {
    const { selectedGroup } = useFAQ()

    if (!selectedGroup) return null

    return (
        <div className='max-w-[1134px] px-5 mx-auto mt-10 mb-5'>
            <h3 className='mb-6 text-xl font-bold'>
                {selectedGroup.label}
            </h3>

            <ul className='divide-y divide-gray-200'>
                {selectedGroup.questions.map(({ question, answer }) => (
                    <li>
                        <details className='collapse collapse-arrow'>
                            <summary className='collapse-title px-0 py-5 text-salmon font-semibold uppercase after:!w-3 after:!h-3 after:!right-2'>
                                {question}
                            </summary>

                            <div
                                className='institutional-hyperlinks collapse-content px-0 text-[#5f5f5f]'
                                dangerouslySetInnerHTML={{ __html: answer }}
                            />
                        </details>
                    </li>
                ))}
            </ul>
        </div>
    )
}
